import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '..';
const Wrapper = styled.div ``;
export const IconArrows = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            const allLayer = wrapper?.querySelectorAll('path');
            if (!allLayer) {
                return;
            }
            gsap.to(allLayer, {
                keyframes: [
                    {
                        x: (index) => (index === 0 ? -2 : 2),
                        duration: 0.1,
                    },
                    {
                        x: (index) => (index === 0 ? 0.5 : -0.5),
                        duration: 0.15,
                    },
                    {
                        x: 0,
                        duration: 0.25,
                        onComplete: triggerDone,
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Swap, null)));
};
//# sourceMappingURL=Arrows.js.map